import { css } from 'aphrodite';
import * as React from 'react';
import { IKeepInTouchJobConfiguration } from '../../../../../models/KeepInTouchAgent';
import { useKeepInTouchConfigurations } from '../../../../../queries/KeepInTouchAgent';
import { Button } from '../../../../components-v2/Button';
import { Skeleton } from '../../../../components-v2/Skeleton';
import { ConfigurationCard } from './ConfigurationCard';
import { ConfigurationDialog } from '../ConfigurationDialog';
import { InstructionsPanel } from '../InstructionsPanel';
import { styleSheet } from './styles';

interface ConfigurationListProps {
	onViewScores: (configId: string) => void;
	onBack?: () => void;
}

export const ConfigurationList: React.FC<ConfigurationListProps> = ({ onViewScores, onBack }) => {
	const { data: configs, isLoading } = useKeepInTouchConfigurations();
	const [dialogOpen, setDialogOpen] = React.useState(false);
	const [editingConfig, setEditingConfig] = React.useState<IKeepInTouchJobConfiguration | null>(null);

	const handleEdit = (config: IKeepInTouchJobConfiguration) => {
		setEditingConfig(config);
		setDialogOpen(true);
	};

	const handleCreate = () => {
		setEditingConfig(null);
		setDialogOpen(true);
	};

	if (isLoading) {
		return (
			<div>
				<Skeleton style={{ height: 72, marginBottom: 12 }} />
				<Skeleton style={{ height: 72, marginBottom: 12 }} />
				<Skeleton style={{ height: 72 }} />
			</div>
		);
	}

	const hasConfigs = !!configs?.length;

	return (
		<>
			<div className={css(styleSheet.header)}>
				{onBack ? (
					<Button variant='link' size='sm' onClick={onBack} styles={[styleSheet.backButton]}>
						&larr; Back
					</Button>
				) : null}
				<h2 className={css(styleSheet.title)}>Manage Jobs</h2>
				<Button onClick={handleCreate}>New Configuration</Button>
			</div>
			<InstructionsPanel defaultExpanded={!hasConfigs} />
			{hasConfigs ? (
				<div className={css(styleSheet.list)}>
					{configs.map(config => (
						<ConfigurationCard key={config.id} config={config} onEdit={handleEdit} onViewScores={onViewScores} />
					))}
				</div>
			) : (
				<div className={css(styleSheet.emptyState)}>
					<p className={css(styleSheet.emptyStateText)}>
						No configurations yet. Create one to start finding contacts to reach out to.
					</p>
					<Button onClick={handleCreate}>Create Your First Configuration</Button>
				</div>
			)}
			<ConfigurationDialog open={dialogOpen} onOpenChange={setDialogOpen} editingConfig={editingConfig} />
		</>
	);
};
